/** Explicit opt-in for local demos; never inferred from an attorney's identity. */
export const isDemoEnvironment = () =>
	import.meta.env.VITE_DEMO_MODE === "true" ||
	(typeof window !== "undefined" &&
		window.location.hostname === "demo.hourglass.law");
